/**
 * College Picker
 */
$(document).on("ready", function () {
  $(document).on("click", ".select-college__results .folder-nav", function (e) {
    e.preventDefault();
    $(".tab").removeClass("active");
    $(".folder-nav").removeClass("active");
    $("#tab" + $(this).data("which")).addClass("active");
    $(this).addClass("active");
  });
  $(document).on("input", ".select-college__choose #selectCollege", function (e) {
    if (!$(".select-college__results_all").hasClass("active")) {
      $(".select-college__results > div").removeClass("active");
      $(".select-college__results_all").addClass("active");
    }
    var $foldernav = $(".folder-nav");
    var $tabs = $(".select-college__results .tab");
    if ($(this).val() != "") {
      if (!$tabs.hasClass("show")) $tabs.addClass("show");
      if (!$foldernav.hasClass("hidden")) $foldernav.addClass("hidden");
      $(".tab p").addClass("hidden");
      $('.tab p[data-name*="' + $(this).val().toLowerCase() + '"]').removeClass("hidden");
    } else {
      $tabs.removeClass("show");
      $foldernav.removeClass("hidden");
      $(".tab p").removeClass("hidden");
    }
  });
  $(document).on("click", ".select-college__choose #my-colleges", function (e) {
    e.preventDefault();
    if (!$(".select-college__results_list").hasClass("active")) {
      $(".select-college__results > div").removeClass("active");
      $(".select-college__results_list").addClass("active");
    }
  });
  $(document).on("click", ".select-college__choose #browse-colleges", function (e) {
    e.preventDefault();
    var $foldernav = $(".folder-nav");
    var $tabs = $(".select-college__results .tab");
    if (!$(".select-college__results_all").hasClass("active")) {
      $(".select-college__results > div").removeClass("active");
      $(".select-college__results_all").addClass("active");
    }
    $tabs.removeClass("show");
    $foldernav.removeClass("hidden");
    $(".tab p").removeClass("hidden");
  });
});
